import { useState } from 'react';
import { information } from "../../data/information";
import ProfileSidebar from './components/ProfileSidebar';
import ProfileContent from './components/ProfileContent';
import PhotographySection from './components/PhotographySection';
import SecuritySection from './components/SecuritySection';
import PrivacySection from './components/PrivacySection';
import MyProfileSection from './components/MyProfileSection';
import { Typography } from '@mui/material';


export default function CourseProfile() {
  const [activeSection, setActiveSection] = useState('public-profile');

  const renderContent = () => {
    switch (activeSection) {
      case 'public-profile':
        return <ProfileContent information={information} />;
      case 'my-profile':
        return <MyProfileSection information={information} />;
      case 'photography':
        return <PhotographySection />;
      case 'security':
        return <SecuritySection />;
      case 'privacy':
        return <PrivacySection />;
      default:
        return <ProfileContent information={information} />;
    }
  };

  const getSectionTitle = () => {
    const titles = {
      'public-profile': 'Perfil público',
      'my-profile': 'Mi perfil',
      'photography': 'Fotografía',
      'security': 'Seguridad de la cuenta',
      'privacy': 'Privacidad',
    };
    return titles[activeSection] || 'Perfil público';
  };

  return (
    <div className="flex justify-center items-center min-h-screen p-4">
      <div className="flex flex-col md:flex-row bg-white rounded-2xl shadow-lg overflow-hidden w-full max-w-5xl">
        <ProfileSidebar 
          information={information}
          activeSection={activeSection}
          onSectionChange={setActiveSection}
        />
        
        <div className="w-full md:w-2/3 p-6">
          <Typography
           variant="h4"
           gutterBottom
           sx={{
               fontWeight: 'bold',
               color: '#4d4d4d',
              textAlign: 'center',
           mb: 4,
           }}
         >
          {getSectionTitle()}
          </Typography>

          {renderContent()}
        </div>
      </div>
    </div>
  );
}
